"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decorators = void 0;

var _index = require("../index");

var decorators = [_index.withActions];
exports.decorators = decorators;